export type DocumentType = 'INVOICE' | 'REFERRAL' | 'PRE_INVOICE' | 'ORDER' | 'GENERAL';

export interface ExternalFile {
    fileName: string;
    url: string;
    contentType: string;
    size: number;
    path?: string;
}

export interface ExternalDocument {
    id: string;
    folio: string;
    status: 'PENDIENTE_ANALISIS' | 'EN_PROCESO' | 'COMPLETADO' | 'ERROR';
    document_type: DocumentType;
    files: ExternalFile[];
    createdAt: Date;
    updatedAt: Date;
    deleted?: boolean;
    ia_retries?: number;
    // --- NUEVO CAMPO ---
    analysis_logs?: any; // Utilizar 'any' o importar AnalysisJobDetail si está disponible
}

// Alias for backward compatibility if needed, or just replace usages.
export type OperatorDocument = ExternalDocument;

export type ProcessorType = 'GPU';

export const PROCESSOR_OPTIONS = [
    {
        value: 'GPU',
        label: 'Procesador GPU',
        description: 'Procesamiento acelerado',
        disabled: false
    }
];